import React, { useState } from "react";
import { Form } from "react-final-form";
import { Button, Modal, SimpleCheckboxControlled, TextInput } from "@truevault/aquilo";
import { requiredString } from "../../util/validation";
import { OrganizationDto } from "../../../common/service/server/dto/OrganizationDto";
import { DpoValues } from "./EditDpoDialog";

type EditPipedaPrivacyOfficerProps = {
  open: boolean;
  onClose: () => void;
  onDone: (vals: PipedaOfficerValues) => void;
  values: PipedaOfficerValues;
  organization: OrganizationDto;
  dpo?: DpoValues;
};

export type PipedaOfficerValues = {
  name: string | undefined;
  email: string | undefined;
  phone: string | undefined;
  address: string | undefined;
};

export const EditPipedaPrivacyOfficerDialog: React.FC<EditPipedaPrivacyOfficerProps> = ({
  open,
  onClose,
  onDone,
  values,
  organization,
  dpo,
}) => {
  const [lock, setLock] = useState(false);

  if (!open) return null;

  const close = () => {
    setLock(false);
    onClose();
  };

  const handleSubmit = (vals: PipedaOfficerValues) => {
    close();
    onDone(vals);
  };

  const validate = (vals: PipedaOfficerValues) => {
    const errors = {} as { [x: string]: string };
    requiredString(vals, "name", errors);
    requiredString(vals, "email", errors);
    return errors;
  };

  return (
    <Modal
      title="Canadian Privacy Officer"
      alignText="left"
      closeButton
      showOverlay
      onClose={close}
      contentContainerClasses="w-full"
      contentPadding="px-[24px] pt-5 pb-[4px]"
    >
      <Form
        onSubmit={handleSubmit}
        validate={validate}
        initialValues={values}
        render={({ handleSubmit, valid, form }) => (
          <form
            onSubmit={handleSubmit}
            className="flex flex-col gap-[6px]"
            style={{ marginRight: "-16px" }}
          >
            {organization.featureGdpr && (
              <SimpleCheckboxControlled
                name="use-dpo-contact-info"
                checked={lock}
                disabled={!dpo}
                label="Use DPO contact information."
                onChange={(checked) => {
                  if (checked && dpo) {
                    setLock(true);
                    form.change("name", dpo.name);
                    form.change("email", dpo.email);
                    form.change("phone", dpo.phone);
                    form.change("address", dpo.address);
                  } else {
                    setLock(false);
                  }
                }}
              />
            )}

            <div className="flex flex-col gap-[6px]">
              <TextInput field="name" label="Name or Title" required autoFocus disabled={lock} />
              <TextInput
                field="email"
                label="Email Address"
                type="email"
                required
                disabled={lock}
              />
              <TextInput field="phone" label="Telephone number (optional)" disabled={lock} />
              <TextInput field="address" label="Physical address (optional)" disabled={lock} />
            </div>

            <div className="flex justify-end items-center gap-[12px]">
              <Button color="tertiary" onClick={close}>
                Cancel
              </Button>
              <Button color="primary" type="submit" disabled={!valid} onClick={() => {}}>
                Update
              </Button>
            </div>
          </form>
        )}
      />
    </Modal>
  );
};
